// modal with dialog
import { getDarkMode } from '@/utils/Settings';

export const getModalStyle = () => {

    const darkmode = getDarkMode();

    const sxDialog = {
        '& .MuiPaper-root.MuiDialog-paper': {
            margin: 0,            
            width: '97%',   
            //minHeight: '400px',
            maxHeight: '96%',
            borderRadius : '5px',
            backgroundColor: darkmode ? '#000000' : null,
            border: darkmode ? '1px solid rgb(255,255,255,0.5)' : null,
            //maxWidth: '95%'
        },
        //zIndex: 99999
    }

    const sxDialogFullHeight = {
        '& .MuiPaper-root.MuiDialog-paper': {
            margin: 0,            
            width: '97%',
            //minHeight: '400px',
            //maxHeight: '96%',
            height: '96%',
            borderRadius : '5px',
            backgroundColor: darkmode ? '#000000' : null,
            border: darkmode ? '1px solid rgb(255,255,255,0.5)' : null,
            //maxWidth: '95%'
        },
        //zIndex: 99999
    };

    const sxDialogMinHeight = {
        '& .MuiPaper-root.MuiDialog-paper': {
            margin: 0,            
            width: '97%',
            minHeight: '400px',
            maxHeight: '96%',
            borderRadius : '5px',
            backgroundColor: darkmode ? '#000000' : null,
            border: darkmode ? '1px solid rgb(255,255,255,0.5)' : null,
            //maxWidth: '95%'
        },
        //zIndex: 99999
    };

    const sxDialogFileViewer = {
        '& .MuiPaper-root.MuiDialog-paper': {
            margin: 0,
            width: '97%',
            //maxWidth: '100%',
            //height: '95%',
            maxHeight: '96%',
            borderRadius : '5px',
            border: darkmode ? '1px solid rgb(255,255,255,0.5)' : null,
        },
        //zIndex: 99999    
    }

    const sxDialogImageViewer = {
        '& .MuiPaper-root.MuiDialog-paper': {
            margin: 0,
            maxWidth: '97%',
            //width: '97%',
            //maxWidth: '100%',
            //height: '95%',
            minWidth: '200px',
            minHeight: '120px',
            maxHeight: '96%',
            borderRadius : '5px',
            border: darkmode ? '1px solid rgb(255,255,255,0.5)' : null,
        },
        //zIndex: 99999    
    }

    const sxDialogContentFileViewer = {
        paddingY: 0,
        paddingX: 0
    };

    const sxDialogTitle = {
        fontWeight: 'bold',
        textAlign: 'center'        
    };

    const sxDialogTitleFileViewer = {
        fontWeight: 'bold',
        textAlign: 'center',
        marginTop: '0px',
        marginRight: '0px',        
        paddingTop: '10px',
        paddingBottom: '10px',
        borderBottom: '1px solid gray'
    }

    const sxList = { 
        pt: 0,
        minWidth: '300px'
    };

    const sxListItem = {
        paddingX: 5,
        borderBottom: '1px solid rgb(0,0,0,0.1)'
    };

    const sxListItemSelected = {
        paddingX: 5,
        borderBottom: '1px solid rgb(0,0,0,0.1)',
        backgroundColor: 'rgb(129,0,0,0.2)'
    };

    const sxAvatar = { 
        bgcolor: "#FFFFFF", 
        color: "rgb(129,0,0,0.5)" 
    };    

    const sxChipNoColor = {
        zIndex: 1,
        padding: '0px 0px 0px 0px', 
        margin: '3px 3px 3px 0px',  
        '& .MuiChip-deleteIcon' : {
            color: '#810000'
        }
    };

    const sxChip = {...sxChipNoColor,
        backgroundColor:'rgb(129,0,0,0.2)',
        //width: "auto",
        maxWidth: "100%",
        overflow: "hidden",
        "& .MuiChip-label": {
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100%"
        }        
    };

    // chip when dropdown and not inside the select
    const sxChipOut = {
        zIndex: 1,
        padding: '0px 0px 0px 0px', 
        margin: '5px 0px 0px 0px',
        backgroundColor:'rgb(129,0,0,0.2)',
        '& .MuiChip-deleteIcon' : {
            color: '#810000'
        }
    };

    const sxCloseIcon = {
        position: 'absolute',
        right: 8,
        top: 8,
        //color: theme.palette.grey[500],
        color: darkmode ? '#FFFFFF' : '#000000'
    };

    const sxDialogContent = 'max-sm:!p-3 !pt-4';

    return { 
        sxDialog, 
        sxDialogFileViewer, 
        sxDialogFullHeight, 
        sxDialogMinHeight, 
        sxDialogTitle, 
        sxDialogTitleFileViewer, 
        sxDialogContentFileViewer, 
        sxDialogImageViewer,
        sxList, sxListItem, 
        sxListItemSelected, 
        sxAvatar, 
        sxChip, 
        sxChipOut, 
        sxCloseIcon, 
        sxChipNoColor, 
        sxDialogContent 
    };
}

// modal with modal component
export const getModalTypeStyle = () => {

    const darkmode = false;

    const sx = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',        
        maxWidth: 600,
        //maxHeight: '99%',
        maxHeight: '85%',
        bgcolor: darkmode ? "rgb(38 38 38)" : "background.paper",
        border: darkmode ? "1px solid #fff" : "1px solid #000",
        borderRadius: '5px',
        boxShadow: 24,
        px: 1,
        pt: 1,
        pb: 0,
        m: 0,
    };

    sx.width = '98%';

    const sxCloseIcon = {
        position: 'absolute',
        right: 8,
        top: 8,
        //color: theme.palette.grey[500],
        color: '#000000'
    };

    return { sx, sxCloseIcon };
}